import {useState, useEffect} from 'react';
import {Row, Col} from 'react-bootstrap'
import styled from 'styled-components';

const Copyright = styled.p`
  margin: 0;
`;

const Footer = ({lang='ar',etat}) => {
    const local = lang==='ar' ? "ar-MA" : "en-US"
    const options = {hour12:false, weekday:'long'}
    const [time, Time] = useState("");

    useEffect(() => {
        setTimeout(() => {
            Time((new Date()).toLocaleTimeString(local,options))
        }, 1000);
    },[time]);

    return (
        <Row className="Footer">
            <Col sm={2}>
            <i className="FooterEtat" key="FooterEtat" id="FooterEtat">{etat}</i>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://telegram.me/akademymabot"}><img src="images/s-telegram.png" alt="telegram" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://www.linkedin.com/company/akademyma"}><img src="images/linkedin.png" alt="linkedin" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://x.com/RaisDigital"}><img src="images/x.png" alt="x rep twitter" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://www.facebook.com/akademy.ma"}><img src="images/facebook.png" alt="facebook" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://www.facebook.com/akademy.ma"}><img src="images/instagram.png" alt="instagram" title="instagram" /></a>
            </Col>
            <Col  sm={1}>
            <a target="_blank" rel="noopener noreferrer" href={"https://www.youtube.com/@Akademy-mA"}><img src="images/youtube.png" alt="youtube" title="youtube" /></a>
            </Col>
            <Col  sm={2}>
                <Copyright>&copy; Akademy.mA {new Date().getFullYear()} </Copyright>
            </Col>
            <Col sm={2}>
            <i style={{float:'right'}}>{time}</i>
            </Col>
        </Row>
    )
}

export default Footer;

